import React from 'react';
import { useOutletContext } from 'react-router-dom';
import ReportIndexTab from './ReportIndexTab';
const ReportIndexPage = () => {
  const { user } = useOutletContext();
  const isHR = user?.role === 'assistant_hr' || user?.role === 'hr_head' || user?.role === 'vp' || user?.role === 'cmd' || user?.role === 'admin';
  return (
    <div className="p-6 lg:p-8">
      <ReportIndexTab user={user} isHR={isHR} />
    </div>
  );
};

export default ReportIndexPage;
